export const HOSTING_URL = 'https://api.cloudinary.com/v1_1/dn11nnlb0/image/upload';
